<template>
  <div class="payment-summary-list">
    <PaymentSummaryItem
      :loading="loading"
      :itemName="`Entrada de ${installmentSelected.downPaymentPercentage}%`"
      :value="moneyFilter(installmentSelected.downPaymentValue)"/>

    <PaymentSummaryItem
      :loading="loading"
      itemName="Parcelas"
      :value="installmentValue"
      :valueInfo="installmentValueInfo"
      />

    <PaymentSummaryItem
      :loading="loading"
      itemName="Valor total"
      :itemNameInfo="totalValueInfo"
      :itemNameInfoAtBottom="isMobile()"
      :value="moneyFilter(installmentSelected.totalAmount)"/>
  </div>
</template>

<script>
import StringMixin from '@/mixins/string';
import UtilMixin from '@/mixins/util';
import PaymentSummaryItem from './PaymentSummaryItem.vue';

export default {
  name: 'payment-summary-list',
  components: { PaymentSummaryItem },
  mixins: [StringMixin, UtilMixin],
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    installmentSelected: {
      type: Object,
    },
  },
  computed: {
    installmentValue() {
      const i = this.installmentSelected;
      if (!i) return null;
      return `${i.numberOfInstallments} vezes de ${this.moneyFilter(i.paymentInstallments)}`;
    },
    installmentValueInfo() {
      const i = this.installmentSelected;
      if (!i) return null;
      return `c/ juros de ${this.interestRateFilter(i.interestRatePM)} a.m`;
    },
    totalValueInfo() {
      const i = this.installmentSelected;
      if (!i) return null;
      return `Juros de ${this.interestRateFilter(i.interestRatePM)} a.m. + Encargos. <br> CET máximo de ${this.interestRateFilter(i.cetPA)} a.a.`;
    },
  },
};
</script>

<style lang="scss" scoped>
.payment-summary-list {
  background: var(--gray-100);
  padding: 0 16px;
}
</style>
